import { useContext, useMemo } from 'react';
import ThemeContext from '../contexts/themeContext';

/**
 * 主题相关颜色变量
 */
export interface ThemeColors {
  /** 卡片/图标背景色 */
  cardBg: string;
  /** 次要背景色 */
  secondaryBg: string;
  /** 主文字颜色 */
  textPrimary: string;
  /** 次要文字颜色 */
  textSecondary: string;
  /** 禁用/占位文字颜色 */
  textMuted: string;
  /** 边框颜色 */
  border: string;
}

export default function useDarkMode() {
  const { darkModeStatus, setDarkModeStatus } = useContext(ThemeContext);

  const themeStatus: 'dark' | 'light' = darkModeStatus ? 'dark' : 'light';

  // 主题相关颜色
  const themeColors: ThemeColors = useMemo(
    () => ({
      cardBg: darkModeStatus ? 'rgba(255,255,255,0.08)' : '#f5f5f5',
      secondaryBg: darkModeStatus ? 'rgba(255,255,255,0.03)' : '#fafafa',
      textPrimary: darkModeStatus ? '#fff' : '#212529',
      textSecondary: darkModeStatus ? 'rgba(255,255,255,0.7)' : '#495057',
      textMuted: darkModeStatus ? 'rgba(255,255,255,0.4)' : '#adb5bd',
      border: darkModeStatus ? 'rgba(255,255,255,0.1)' : 'var(--bs-border-color)',
    }),
    [darkModeStatus],
  );

  return { themeStatus, darkModeStatus, setDarkModeStatus, themeColors };
}
